import {
  AppPageHeader,
  ColumnsType,
  EditIcon,
  Group,
  InfiniteTable,
} from '@/components/_common';
import ModalLoadingOverlay from '@/components/_common/ModalLoadingOverlay';
import { useCustomerCategoryList } from '@/core/domain/people/CustomerCategory/CustomerCategory.hooks';
import {
  CustomerCategory,
  ListCustomersCategoryQuery,
} from '@/core/domain/people/CustomerCategory/CustomerCategory.types';
import { useDebounce, useDisclosure, useWindowSize } from '@/hooks';
import { flatInfiniteData } from '@/utils/request/flatInfiniteData';
import { Button, Divider, Modal, ModalProps, Space, Tag } from 'antd';
import { useState } from 'react';
import { CheckOutlined } from '@ant-design/icons';
import CategoryModal from '@/components/Settings/Customer/Category/CategoryModal';

interface Props extends Omit<ModalProps, 'onCancel'> {
  onCancel: VoidFunction;
  onCallback: (categoryId: number) => void;
}

export default function CustomerCategorySelectModal({
  onCallback,
  onCancel,
  ...props
}: Props) {
  const { isMobile } = useWindowSize();

  const [modalOpened, modalActions] = useDisclosure();

  const [queryParams, setQueryParams] = useState<ListCustomersCategoryQuery>({
    order: 'ASC',
  });
  const [catetoryId, setCategoryId] = useState<number>();

  const queryDebounce = useDebounce(queryParams, 500);

  const list = useCustomerCategoryList(queryDebounce, props.open);

  const categories = flatInfiniteData(list.data);

  function handleCancel() {
    onCancel();
  }

  function handleCallback(categoryId: number) {
    onCallback(categoryId);

    handleCancel();
  }

  const columns: ColumnsType<CustomerCategory> = [
    {
      dataIndex: 'name',
      title: 'Descrição',
      render: (_, record) => (
        <Tag color={record.color}>{record.name.toUpperCase()}</Tag>
      ),
    },
    {
      dataIndex: 'actions',
      align: 'right',
      render: (_, row) => (
        <Space direction="horizontal" size="middle" style={{ display: 'flex' }}>
          <EditIcon
            size={24}
            iconProps={{
              onClick: () => {
                setCategoryId(row.id);
                modalActions.open();
              },
            }}
          />

          <Divider type="vertical" />

          <Button
            type="primary"
            onClick={() => handleCallback(row.id)}
            icon={<CheckOutlined />}
          />
        </Space>
      ),
      width: 50,
    },
  ];

  return (
    <>
      <Modal
        {...props}
        title="Selecionar categoria"
        footer={[]}
        onCancel={handleCancel}
      >
        {props.confirmLoading && (
          <ModalLoadingOverlay
            style={{
              position: 'absolute',
              width: '100%',
              height: '100%',
              backdropFilter: 'blur(2px)',
            }}
            messages={['Incluindo Categoria...']}
          />
        )}

        <Group
          position="between"
          align="center"
          gap={24}
          style={{ flexDirection: isMobile ? 'column' : undefined }}
        >
          <AppPageHeader
            searchValue={queryParams.name}
            onSearch={(value) =>
              setQueryParams((prev) => ({ ...prev, name: value }))
            }
          />

          <Button
            type="primary"
            onClick={modalActions.open}
            style={{ marginBottom: 24 }}
          >
            Criar Categoria
          </Button>
        </Group>

        <InfiniteTable<CustomerCategory>
          columns={columns}
          dataSource={categories}
          loading={list.isFetching}
          rowKey={(row) => row.id}
          hasNextPage={list.hasNextPage}
          fetchNextPage={list.fetchNextPage}
        />
      </Modal>

      <CategoryModal
        open={modalOpened}
        onCancel={() => {
          setCategoryId(undefined);
          modalActions.close();
        }}
        categoryId={catetoryId}
      />
    </>
  );
}
